import * as React from "react";
type Props = {
  className?: string,
};
function SvgOpenBox({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Open Box"
      className={className}
    >
      <path
        d="M34.1795 14.1768H5.86377V34.5049H34.1795V14.1768Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M13.0598 11.7964L9.41845 5.35913H1.68494L5.80312 14.0116L13.0338 11.7356H26.9402L34.1969 14.142L38.3151 5.48944H30.5816L27.0009 11.7964"
        fill="#F9F6F2"
      />
      <path
        d="M13.0598 11.7964L9.41845 5.35913H1.68494L5.80312 14.0116L13.0338 11.7356H26.9402L34.1969 14.142L38.3151 5.48944H30.5816L27.0009 11.7964"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M15.2013 29.0057C15.3527 27.8007 15.9379 26.6924 16.847 25.889C17.7561 25.0857 18.9267 24.6424 20.1388 24.6424C21.3509 24.6424 22.5213 25.0857 23.4304 25.889C24.3395 26.6924 24.9246 27.8007 25.0761 29.0057H29.5673C29.5153 28.6235 28.7609 23.246 24.0531 21.0482C22.1004 20.1646 19.9076 19.9657 17.8282 20.4835C16.3329 20.8761 14.9536 21.6233 13.8068 22.662C12.66 23.7007 11.7794 25.0004 11.2391 26.4517C10.9355 27.2715 10.7573 28.1326 10.7103 29.0057H15.2013Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgOpenBox;
